import { Card, HeaderGradient, MiniCard, Row } from '@app/components';
import React, { memo } from 'react';
import SvgInfo from '@app/components/icons/SvgInfo';
import { SlantTitle } from '@app/components/typography';
import { theme } from '@app/theme';
import { useDynamicSizes } from '@app/hooks';
import LinearGradient from 'react-native-linear-gradient';
import { StyleSheet } from 'react-native';
import { ILoyalty } from '@app/common';
import { UseFormReturn } from 'react-hook-form';

type LoyaltyCardProps = {
  loyalty?: Partial<ILoyalty>;
  formMethods: UseFormReturn<any, any, any>;
};

export const LoyaltyCard = memo(({ loyalty }: LoyaltyCardProps) => {
  const { subContainerHeight } = useDynamicSizes();

  return (
    <Card>

      <HeaderGradient>
        <LinearGradient
          start={{ x: 0.5, y: 0 }}
          end={{ x: 0.5, y: 1 }}
          locations={[0, 1]}
          colors={['rgba(253, 255, 252, 0)', 'rgba(253, 255, 252, 1)']}
          style={styles.headerGradient}
        />
      </HeaderGradient>

      <Card.TopHeader>
        <Card.TopHeaderLabel>Fiche programme de fidélité</Card.TopHeaderLabel>
      </Card.TopHeader>

      <Card.Container height={subContainerHeight}>
        <Card.Background source={require('@app/assets/img/cardbackground.png')} />

        <Card.Content>
          <Card.Header>
            <Row justify="space-between" align="center">
              <Card.HeaderTitles>
                <Card.Title numberOfLines={2}>Programme de fidélité</Card.Title>
                {loyalty?._id && <Card.Subtitle>Ref: {loyalty._id}</Card.Subtitle>}
              </Card.HeaderTitles>
            </Row>
          </Card.Header>
        </Card.Content>

        <MiniCard>
          <MiniCard.Tabs>
            <MiniCard.TabsHolder>
              <MiniCard.Tab Icon={SvgInfo} isActive />
            </MiniCard.TabsHolder>
          </MiniCard.Tabs>
          <MiniCard.Container>
            <MiniCard.Content>
              <SlantTitle label="Aide" color={theme.colors.gold} />
              <Card.HelpScrollContainer style={{ paddingBottom: 24, paddingTop: 8 }}>
                <Card.LineBreak height={16} />

                <Card.HelpTitle>Fonctionnement du programme fidélité</Card.HelpTitle>

                <Card.LineBreak height={8} />

                <Card.HelpText>Le programme repose sur un système de paliers.</Card.HelpText>

                <Card.HelpText>Chaque palier correspond à un niveau de fidélité que vos clients peuvent atteindre en achetant des produits.</Card.HelpText>

                <Card.HelpText>Lorsqu'un client atteint un palier, il débloque la possibilité de choisir ce palier ou un palier inférieur comme récompense.</Card.HelpText>

                <Card.HelpSubtitle>Exemples :</Card.HelpSubtitle>

                <Card.HelpExample>Palier 1 : 50 points → Menu Classique offert</Card.HelpExample>

                <Card.HelpExample>Palier 2 : 100 points → Menu Gourmand offert</Card.HelpExample>

                <Card.LineBreak height={16} />

                <Card.HelpText>Ce système vous permet de fidéliser vos clients en leur offrant des avantages progressifs et attractifs.</Card.HelpText>

                <Card.LineBreak height={185} />
              </Card.HelpScrollContainer>
            </MiniCard.Content>
          </MiniCard.Container>
        </MiniCard>
      </Card.Container>
    </Card>
  );
});

const styles = StyleSheet.create({
  headerGradient: {
    flex: 1,
    height: theme.sizes.listHeaderHeight,
  },
});
